import {
  MockMap,
} from '@ama-sdk/core';
import {
  AcceptanceRepository,
  combineCheckInBaggagePolicies,
  createMockData,
  createMockDataWithResponse,
} from '@dapi/sdk/spec';
import {
  acceptedJourney,
  defaultBoardingPassResult,
  journeys,
  seatmap,
  weightCheckInBaggagePolicies,
} from '../../mock/data';

/**
 * OW 1Journey
 * 1ADT
 * Baggage allowances only in Weights
 */
export const ow1Journey1AdtBaggageAllowanceOnlyWeight: MockMap = {
  getBaggagePoliciesFromJourney: [
    createMockData(combineCheckInBaggagePolicies([weightCheckInBaggagePolicies]).items)
  ],
  requestAcceptanceOfJourney: [
    createMockDataWithResponse(AcceptanceRepository.TWO_SECURITY_QUESTIONS, 201),
    createMockDataWithResponse(AcceptanceRepository.ACCEPTED, 201)
  ],
  retrieveJourneyBaggages: [createMockData([])],
  retrieveJourneys: [
    createMockDataWithResponse(journeys, 201),
    createMockDataWithResponse([acceptedJourney], 201)
  ],
  retrieveJourney: [
    createMockData(acceptedJourney)
  ],
  retrieveSeatMapsJourneyDriven: [createMockData(seatmap)],
  generateBoardingPasses: [createMockDataWithResponse(defaultBoardingPassResult, 201)]
};
